import { CardId } from '../../model/cards';

export const REMOVE_DEBUFF_CARDS = [CardId.Purify, CardId.Wish4];

export const REMOVE_BUFF_CARDS = [CardId.Dispel, CardId.Wish2, CardId.Ambush];

export const POWERFUL_CARDS = [
  CardId.Flame,
  CardId.Resurrect,
  CardId.Aura,
  CardId.Wish3,
  CardId.Wish5,
  CardId.Tide,
  CardId.Revenge,
  CardId.Poison,
];

export const USELESS_CARDS = [CardId.Wish1];
